import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

import { useSearchParams } from "react-router-dom";
import { useStatusMissing } from "../../../../reactQuery/statusMissing";
import {
  filterMissingStatusByUsers,
  formatMissingStatusCsvRows,
  formatMissingStatusRows,
  getMissingStatusDateParams,
} from "../utils/reportUtils";

export function useMissingStatusReport() {
  const [searchParams] = useSearchParams();
  const groupingUser = useSelector(
    (state) => state.groupingUser.allocationUsers
  );
  const { startDate, endDate } = useMemo(
    () =>
      getMissingStatusDateParams(
        searchParams.get("missingStatus"),
        searchParams.get("missingStatusFrom"),
        searchParams.get("missingStatusDays")
      ),
    [searchParams]
  );
  const { isLoading, error, statusMissing, isError, refetch, isRefetching } =
    useStatusMissing({ start_date: startDate, end_date: endDate });

  useEffect(() => {
    refetch();
  }, [endDate, refetch, startDate]);

  const rawRows = useMemo(
    () => formatMissingStatusRows(statusMissing?.data?.data?.responseData || []),
    [statusMissing]
  );

  const rows = useMemo(
    () => filterMissingStatusByUsers(rawRows, groupingUser),
    [groupingUser, rawRows]
  );

  const csvRows = useMemo(
    () =>
      formatMissingStatusCsvRows(
        filterMissingStatusByUsers(
          statusMissing?.data?.data?.responseData || [],
          groupingUser
        )
      ),
    [groupingUser, statusMissing]
  );

  return {
    rows,
    csvRows,
    isLoading,
    error,
    isError,
    isRefetching,
  };
}
